import { ReferenceLine } from 'recharts';

// @ts-ignore
ReferenceLine.defaultProps.stroke = '#bdc4c6';
// @ts-ignore
ReferenceLine.defaultProps.strokeDasharray = '3';

export { ReferenceLine };
